<div class="login-alliance content-without-footer d-flex">
    <app-sprintpay-login class="position-absolute" [sourceSignUp]="'alliance'" [widthLogo]="'180'" [heightLogo]="'131'">
        <ng-container login-verbiage>
            <h4 class="mat-subtitle-1 text-center align-self-center">
                Please enter your AGI/CargoSprint - Sprintpay credentials to access your Bank Account (ACH), credit
                cards and SprintPay Credit
            </h4>
        </ng-container>
    </app-sprintpay-login>
</div>
